var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1165)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1165)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.511 56.2126C28.511 58.0563 29.6644 59.3118 31.2547 59.3118C32.6592 59.3118 33.5473 58.5103 33.7199 57.3214H32.394C32.2888 57.8555 31.851 58.1496 31.2681 58.1496C30.3799 58.1496 29.837 57.3348 29.837 56.2126C29.837 55.0896 30.3799 54.2748 31.2681 54.2748C31.851 54.2748 32.2888 54.5689 32.394 55.1029H33.7199C33.5473 53.914 32.6592 53.1126 31.2547 53.1126C29.6644 53.1126 28.511 54.3681 28.511 56.2126ZM40.0836 56.2126C40.0836 54.3948 38.9436 53.1126 37.2873 53.1126C35.6303 53.1126 34.491 54.3948 34.491 56.2126C34.491 58.0296 35.6303 59.3118 37.2873 59.3118C38.9436 59.3118 40.0836 58.0296 40.0836 56.2126ZM38.7577 56.2126C38.7577 57.3348 38.2414 58.1629 37.2873 58.1629C36.3325 58.1629 35.8162 57.3348 35.8162 56.2126C35.8162 55.0896 36.3325 54.2614 37.2873 54.2614C38.2414 54.2614 38.7584 55.0896 38.7584 56.2126H38.7577ZM45.1762 59.1777H46.5021V50.494H45.1762V53.7548C44.911 53.4207 44.3281 53.1133 43.6792 53.1133C41.9562 53.1133 40.9488 54.5163 40.9488 56.2133C40.9488 57.9229 41.9562 59.3126 43.6784 59.3126C44.3281 59.3126 44.911 59.0052 45.1762 58.6718V59.1792V59.1777ZM45.1762 57.3348C45.0579 57.571 44.8764 57.7697 44.6518 57.9089C44.4273 58.048 44.1685 58.1221 43.9044 58.1229C42.8836 58.1229 42.2747 57.3081 42.2747 56.2118C42.2747 55.1163 42.8836 54.3014 43.9044 54.3014C44.4473 54.3014 44.951 54.6222 45.1762 55.0896V57.3348ZM52.674 59.1777V55.2903C52.674 53.9407 51.7992 53.1126 50.3147 53.1126C49.1088 53.1126 48.1814 53.874 48.0088 54.8896H49.2814C49.4266 54.4748 49.7584 54.2481 50.2888 54.2481C51.0436 54.2481 51.4147 54.7155 51.4147 55.317V55.7985C51.1762 55.6244 50.5799 55.437 50.0495 55.437C48.751 55.437 47.757 56.2259 47.757 57.3481C47.757 58.5637 48.751 59.2852 49.957 59.2852C50.6199 59.2852 51.2162 59.0444 51.4147 58.8444V59.1777H52.674ZM51.4147 57.6015C51.2688 57.9755 50.7392 58.2029 50.2088 58.2029C49.6125 58.2029 48.9895 57.9489 48.9895 57.3481C48.9895 56.76 49.6118 56.5059 50.2088 56.5059C50.7392 56.5059 51.2688 56.7333 51.4147 57.1074V57.6015ZM50.7273 20.6874H30.4577C29.8726 20.6884 29.3117 20.9208 28.8974 21.334C28.4831 21.7472 28.2491 22.3075 28.2466 22.8926V44.9385C28.2493 45.5235 28.4834 46.0836 28.8976 46.4966C29.3119 46.9096 29.8727 47.142 30.4577 47.1429H50.7273C51.3123 47.142 51.8731 46.9096 52.2874 46.4966C52.7016 46.0836 52.9357 45.5235 52.9384 44.9385V43.9089C52.9014 42.5866 52.8644 39.8311 52.8644 38.5815C52.8644 37.8837 52.3488 37.2955 51.6851 37.2955C50.9481 37.2955 50.4688 37.7363 50.0999 38.1037C48.9947 39.0963 47.337 39.28 45.8999 39.0222C45.2362 38.8755 44.6095 38.6918 44.0932 38.3615C42.5088 37.4429 41.477 35.7155 41.477 33.8785C41.477 32.0415 42.5088 30.3511 44.0932 29.3955C44.6466 29.0652 45.2725 28.8815 45.8992 28.7348C47.2992 28.477 48.9955 28.6607 50.1007 29.6533C50.5058 30.0207 50.9851 30.4607 51.6858 30.4607C52.3488 30.4607 52.8644 29.8733 52.8644 29.1755C52.8644 27.9629 52.9014 25.1703 52.9384 23.8474V22.8918C52.9355 22.307 52.7014 21.747 52.2871 21.3342C51.8729 20.9213 51.3122 20.6891 50.7273 20.6881V20.6874Z",
    fill: "#A6A6C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1165",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1165",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg10);
export default __webpack_public_path__ + "static/media/productivityimg10.29bf6a743660b049e1828d8739fea245.svg";
export { ForwardRef as ReactComponent };